import { render } from "./HomeAlertBar.vue?vue&type=template&id=39b5192c&ts=true"
import script from "./HomeAlertBar.vue?vue&type=script&lang=ts"
export * from "./HomeAlertBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__